
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1a2b4a] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/113d40f7-3d1e-4f22-9757-e253790e804c.png"
                alt="Sherali Hassan Inc"
                className="h-12 w-auto brightness-0 invert"
              />
              <div className="flex flex-col">
                <span className="text-white font-bold text-base leading-tight">Sherali Hassan Inc.</span>
                <span className="text-gray-400 text-xs leading-tight">Chartered Professional Accountant</span>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4">
              CPA Chartered Professional Accountant providing expert financial guidance across British Columbia.
            </p>
            <p className="text-gray-400 italic text-sm">
              Your trusted partner in financial success
            </p>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider uppercase mb-6 text-gray-300">STAY INFORMED</h4>
            <p className="text-gray-400 text-sm mb-4">Subscribe to our newsletter for financial tips and updates</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-sm focus:outline-none focus:border-amber-400 transition-colors"
              />
              <button 
                className="w-10 h-10 bg-amber-400 rounded-lg flex items-center justify-center hover:bg-amber-500 transition-colors cursor-pointer"
                onClick={(e) => {
                  const input = e.currentTarget.previousElementSibling as HTMLInputElement;
                  if (input && input.value) {
                    console.log('Subscribed:', input.value);
                    input.value = '';
                  }
                }}
              >
                <i className="ri-arrow-right-line text-white"></i>
              </button>
            </div>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider uppercase mb-6 text-gray-300">QUICK LINKS</h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'About Us', path: '/about' },
                { name: 'Services', path: '/services' },
                { name: 'Locations', path: '/locations' },
                { name: 'Contact', path: '/contact' }
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white hover:text-amber-400 transition-all duration-300 hover:translate-x-1 inline-block cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect Column */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider uppercase mb-6 text-gray-300">CONNECT</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="#" 
                  className="flex items-center gap-3 text-white hover:text-amber-400 transition-all duration-300 hover:translate-x-1 cursor-pointer"
                  onClick={(e) => e.preventDefault()}
                >
                  <i className="ri-linkedin-fill text-xl"></i>
                  LinkedIn
                </a>
              </li>
              <li>
                <a 
                  href="#" 
                  className="flex items-center gap-3 text-white hover:text-amber-400 transition-all duration-300 hover:translate-x-1 cursor-pointer"
                  onClick={(e) => e.preventDefault()}
                >
                  <i className="ri-facebook-fill text-xl"></i>
                  Facebook
                </a>
              </li>
              <li>
                <a 
                  href="#" 
                  className="flex items-center gap-3 text-white hover:text-amber-400 transition-all duration-300 hover:translate-x-1 cursor-pointer"
                  onClick={(e) => e.preventDefault()}
                >
                  <i className="ri-twitter-fill text-xl"></i>
                  Twitter
                </a>
              </li>
              <li>
                <a 
                  href="mailto:sherali@sheralihassan.com" 
                  className="flex items-center gap-3 text-white hover:text-amber-400 transition-all duration-300 hover:translate-x-1 cursor-pointer"
                >
                  <i className="ri-mail-fill text-xl"></i>
                  Email
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Large Company Name */}
        <div className="mb-12 overflow-hidden">
          <h2 className="text-6xl lg:text-8xl font-bold text-amber-50/10 tracking-tight">
            SHERALI HASSAN INC
          </h2>
        </div>

        {/* Legal Bar */}
        <div className="pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Sherali Hassan Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-gray-400">
            <a 
              href="#" 
              className="hover:text-amber-400 transition-colors cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              Privacy Policy
            </a>
            <span>|</span>
            <a 
              href="#" 
              className="hover:text-amber-400 transition-colors cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              Terms of Service
            </a>
            <span>|</span>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-amber-400 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
